import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/identification_driverslicense_img_03.svg")